module.exports = __webpack_public_path__ + "img/salon_setting.9db22533.svg";